import { UserPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface HouseholdInviteFormProps {
  showInviteForm: boolean
  inviteEmail: string
  inviteRole: 'admin' | 'member'
  inviteSubmitting: boolean
  onToggle: () => void
  onEmailChange: (value: string) => void
  onRoleChange: (role: 'admin' | 'member') => void
  onSubmit: () => void
}

export function HouseholdInviteForm({
  showInviteForm,
  inviteEmail,
  inviteRole,
  inviteSubmitting,
  onToggle,
  onEmailChange,
  onRoleChange,
  onSubmit,
}: HouseholdInviteFormProps) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <h4 className="text-sm font-medium">Leden Uitnodigen</h4>
        <Button variant="outline" size="sm" onClick={onToggle}>
          <UserPlus className="mr-1 h-4 w-4" />
          Uitnodigen
        </Button>
      </div>

      {showInviteForm && (
        <div className="space-y-2 rounded-lg bg-gray-50 p-3">
          <Input
            type="email"
            placeholder="Email adres"
            value={inviteEmail}
            onChange={(e) => onEmailChange(e.target.value)}
          />
          <div className="flex gap-2">
            <select
              value={inviteRole}
              onChange={(e) => onRoleChange(e.target.value as 'admin' | 'member')}
              className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm"
            >
              <option value="member">Lid</option>
              <option value="admin">Admin</option>
            </select>
            <Button onClick={onSubmit} disabled={inviteSubmitting || !inviteEmail.trim()} size="sm">
              {inviteSubmitting ? 'Versturen...' : 'Uitnodigen'}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
